import React from "react";
import { Link } from "gatsby";
import IconArrowLeft from "../../images/arrow-left.svg";
import DefaultIcon from '../../icons/icon-executive.svg';
import BannerCareer from "../../images/banner-career-page.jpg";
import scrollTo from 'gatsby-plugin-smoothscroll';
import IconArrowBottom from "../../icons/icon-scroll-down.svg";
import LazyLoad from 'react-lazyload';


export default function MainBanner(props) {
  const { title, acf, classes } = props.data;
  return (
      <div className="video-banner common-page-banner-section d-flex flex-wrap align-v-center career-details-banner">
        <div className="full-width-media">
          <LazyLoad>
            <img src={BannerCareer} alt="career" />
          </LazyLoad>
        </div>
        <div className="container">
          <div className="page-banner-detail">
            {/* <div className="section-gap-small">
              <Link to="/careers/" className="back-link"><img src={IconArrowLeft} />Back to All Jobs</Link>
            </div> */} 
            <h1 className="h1">{title}</h1>
            <p>{acf.job_type + ", " + acf.job_location}</p>
            {/*<div className="d-flex align-v-center">
              <div className="title-bar-icon">
                {acf.icon ? <img src={acf.icon.source_url.replace(/testingsite01.rapidops/g, 'mk0rapidopsback40h4t.kinstacdn')} /> : <DefaultIcon />}
                <img src={acf.icon ? acf.icon.source_url : acf.icon_path} /> 
              </div>
              <div className="title-bar-content">
                
              </div>
            </div>
            */} 
          </div>
        </div>
        <div className="scroll-more">
          <div className="scroll-more-inner" onClick={() => scrollTo('.job-info')}>
            <div className="icon-scroll-more"><IconArrowBottom /></div>
            <span>Scroll More</span>
          </div>  
        </div>
      </div>
  );
}
